const storeHelper = {
  getNewStoreUUID () {
    let d = +new Date()
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now() // use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
  },
  convertObjectToFormData (data) {
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }
    return formData
  },
  depersonalize (str) {
    if (!str) {
      str = 'unknown'
    }
    return str.toString().substr(0, str.length / 2) + '***'
  }
}

export default storeHelper
